// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3TV4J","col":"styles_col__2SuA3"};